// This file is auto-generated by ./scripts/parse-webdata.js
// Do not edit this file directly. Instead, edit the Markdown files in src/data/personas/{locale}/

const allCards = {
    en: [
        {
            id: 1,
            name: "Maximiliano Fischer",
            position: "Co-Founder & Chief Executive Officer (CEO)",
            position_long: "Chief Executive Officer",
            image: "mfischer.png",
            email: "max@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/maxfischer/",
            show: true,
            bodyCard: "<p>Aerospace and Astronautical Engineer with deep expertise in space systems, launch vehicles, and advanced micro-technologies. Maximiliano has led critical initiatives from the laboratory to the launchpad, serving as Chief of AI&amp;T for the Tronador II project and directing multiple experimental launch campaigns. As a founder and entrepreneur, he combines technical excellence with a strategic vision, driving the development of disruptive technologies and building high-performance teams for the new space era.</p>\n",
        },
        {
            id: 2,
            name: "C. Alejandro Di Bernardi",
            position: "Co-Founder & Chief Technical Officer (CTO)",
            position_long: "Chief Technical Officer",
            image: "abernardi.png",
            email: "ale@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/alejandro-di-bernardi-147a1a16/",
            show: true,
            bodyCard: "<p>Aeronautical Engineer with over 30 years of international experience in technology, innovation, strategic development, and regulatory application. Alejandro has led complex projects in more than 35 countries, combining a global, systemic vision with execution in the design, planning, operation, and management of infrastructure. His expertise stands out in key sectors such as air transport, advanced mobility, and digital transformation, driving disruptive initiatives focused on real impact, sustainability, and technological scalability.</p>\n",
        },
        {
            id: 3,
            name: "Alberto Lamagna",
            position: "Co-Founder & Chief Strategy Officer (CSO)",
            position_long: "Chief Strategy Officer",
            image: "alamagna.png",
            email: "albert@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/alberto-lamagna-7930a232/",
            show: true,
            bodyCard: "<p>Physicist and Technologist with extensive executive experience leading high-tech R&amp;D and industrial operations at a national scale. Alberto has served as President of Nucleoeléctrica Argentina and Vice President of the CNEA, driving breakthroughs in aerospace, nanotechnology, and energy. His expertise bridges the gap between complex scientific innovation and market application, designing strategic frameworks that transform deep-tech research into scalable, high-impact industrial solutions.</p>\n",
        },
        {
            id: 4,
            name: "Pablo Bolino",
            position: "Co-Founder & Chief Financial Officer (CFO)",
            position_long: "Chief Financial Officer",
            image: "pbolino.png",
            email: "pablo@cosmic-shores.net",
            lkd: "https://www.linkedin.com/in/pablobolino/",
            show: true,
            bodyCard: "<p>Economist and Master in Finance with a solid background in capital markets, public administration, and corporate governance. As co-founder Luz Consulting and a certified Capital Markets expert, Pablo specializes in financial engineering and strategic fundraising. He has served as a high-level advisor for government bodies and presided over municipal entities, bringing a systemic view to economic sustainability. At The Cosmic Shores, he drives the financial architecture needed to secure venture capital and scale complex technological operations.</p>\n",
        },
        {
            id: 5,
            name: "Federico Lamagna",
            position: "Co-Founder & Chief Information Officer (CIO)",
            position_long: "Chief Information Officer",
            image: "flamagna.png",
            email: "federico@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/federico-lamagna/",
            show: true,
            bodyCard: "<p>Physicist and Data Scientist with a strong foundation in complex systems modeling and artificial intelligence. Federico has successfully bridged the gap between theoretical science and applied technology, contributing to critical subsystems for commercial launch vehicles, including GNC and flight termination. Specializing in digital transformation and machine learning, he leads the development of advanced information architectures and agentic AI systems, ensuring the seamless integration of software, data, and strategic innovation.</p>\n",
        },
    ],
    es: [
        {
            id: 1,
            name: "Maximiliano Fischer",
            position: "Co-Founder & Chief Executive Officer (CEO)",
            position_long: "Chief Executive Officer",
            image: "mfischer.png",
            email: "max@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/maxfischer/",
            show: true,
            bodyCard: "<p>Ingeniero Aeroespacial y Aeronáutico con profunda experiencia en sistemas espaciales, vehículos lanzadores y microtecnología avanzada. Maximiliano ha liderado iniciativas críticas desde el laboratorio hasta la plataforma de lanzamiento, desempeñándose como Jefe de AI&amp;T para el proyecto Tronador II y dirigiendo múltiples campañas experimentales. Como fundador y emprendedor, combina la excelencia técnica con una visión estratégica, impulsando el desarrollo de tecnologías disruptivas y la formación de equipos de alto rendimiento para la nueva era espacial.</p>\n",
        },
        {
            id: 2,
            name: "C. Alejandro Di Bernardi",
            position: "Co-Founder & Chief Technical Officer (CTO)",
            position_long: "Chief Technical Officer",
            image: "abernardi.png",
            email: "ale@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/alejandro-di-bernardi-147a1a16/",
            show: true,
            bodyCard: "<p>Ingeniero Aeronáutico con más de 30 años de trayectoria internacional en tecnología, innovación, desarrollo estratégico y aplicación normativa. Alejandro ha liderado proyectos complejos en más de 35 países, combinando una visión sistémica global con la ejecución en diseño, planificación, operación y gestión de infraestructuras. Su experiencia destaca en sectores clave como el transporte aéreo, la movilidad avanzada y la transformación digital, impulsando iniciativas disruptivas con foco en el impacto real, la sostenibilidad y la escalabilidad tecnológica.</p>\n",
        },
        {
            id: 3,
            name: "Alberto Lamagna",
            position: "Co-Founder & Chief Strategy Officer (CSO)",
            position_long: "Chief Strategy Officer",
            image: "alamagna.png",
            email: "albert@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/alberto-lamagna-7930a232/",
            show: true,
            bodyCard: "<p>Físico y Tecnólogo con amplia trayectoria ejecutiva liderando operaciones industriales y de I+D de alta tecnología a escala nacional. Alberto se ha desempeñado como Presidente de Nucleoeléctrica Argentina y Vicepresidente de la CNEA, impulsando avances en los sectores aeroespacial, nanotecnológico y energético. Su experiencia conecta la innovación científica compleja con la aplicación de mercado, diseñando marcos estratégicos que transforman la investigación de vanguardia en soluciones industriales escalables y de alto impacto.</p>\n",
        },
        {
            id: 4,
            name: "Pablo Bolino",
            position: "Co-Founder & Chief Financial Officer (CFO)",
            position_long: "Chief Financial Officer",
            image: "pbolino.png",
            email: "pablo@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/pablobolino/",
            show: true,
            bodyCard: "<p>Economista y Magíster en Finanzas con una sólida trayectoria en mercado de capitales, gestión pública y gobierno corporativo. Como cofundador de Luz Consulting e idóneo certificado en Mercado de Capitales, Pablo se especializa en ingeniería financiera y estrategias de levantamiento de capital. Ha sido asesor estratégico en organismos gubernamentales y presidido entes municipales, aportando una visión sistémica a la sustentabilidad económica. En The Cosmic Shores, lidera la arquitectura financiera necesaria para asegurar capital de riesgo y escalar operaciones tecnológicas complejas.</p>\n",
        },
        {
            id: 5,
            name: "Federico Lamagna",
            position: "Co-Founder & Chief Information Officer (CIO)",
            position_long: "Chief Information Officer",
            image: "flamagna.png",
            email: "federico@cosmic-shores.space",
            lkd: "https://www.linkedin.com/in/federico-lamagna/",
            show: true,
            bodyCard: "<p>Físico y Científico de Datos con una sólida base en modelado de sistemas complejos e inteligencia artificial. Federico ha conectado la ciencia teórica con la tecnología aplicada, contribuyendo en subsistemas críticos para vehículos lanzadores comerciales, incluyendo GNC y sistemas de vuelo. Especializado en transformación digital y aprendizaje automático, lidera el desarrollo de arquitecturas de información avanzadas y sistemas de IA, asegurando la integración estratégica de software, datos e innovación tecnológica.</p>\n",
        },
    ],
};

export default allCards;
